import * as Constants from 'client/util/Constants';
import AgentSetup from 'client/Discover/components/GuidedSetup/AgentSetup.vue';
import LinuxSetup from 'client/Discover/components/GuidedSetup/LinuxSetup.vue';
import MdmSetup from 'client/Discover/components/GuidedSetup/MdmSetup.vue';
import TerminalSetup from 'client/Discover/components/GuidedSetup/TerminalSetup.vue';

const { mac, windows, linux } = Constants.default;

export const guidedSetupInstallTypes = {
  chef: 'chef',
  manual: 'manual',
  mdm: 'mdm',
  powershell: 'powershell',
  puppet: 'puppet',
  terminal: 'terminal',
};

const {
  chef,
  manual,
  mdm,
  powershell,
  puppet,
  terminal,
} = guidedSetupInstallTypes;

export const guidedSetupInstallOptions = {
  [chef]: {
    header: 'Install via Chef',
    label: 'Chef',
    value: chef,
  },
  [manual]: {
    header: 'Install Manually',
    label: 'Manually',
    value: manual,
  },
  [mdm]: {
    header: 'Install via MDM Enrollment',
    label: 'MDM Enrollment',
    value: mdm,
  },
  [powershell]: {
    header: 'Install via PowerShell',
    label: 'PowerShell',
    value: powershell,
  },
  [puppet]: {
    header: 'Install via Puppet',
    label: 'Puppet',
    value: puppet,
  },
  [terminal]: {
    header: 'Install via Terminal',
    label: 'Terminal',
    value: terminal,
  },
};

export const guidedSetupConfig = {
  [mac]: {
    icon: 'apple',
    installOptions: [
      {
        ...guidedSetupInstallOptions.mdm,
        component: MdmSetup,
        images: {
          default: 'url("/img/growth/device-setup-mac.png")',
          steps: [
            'url("/img/growth/device-setup-mdm-configured.png")',
            'url("/img/growth/device-setup-success.png")',
          ],
        },
      },
      {
        ...guidedSetupInstallOptions.manual,
        component: AgentSetup,
        images: {
          default: 'url("/img/growth/device-setup-mac-manual.png")',
          steps: [
            'url("/img/growth/device-setup-mac-agent-1.png")',
            'url("/img/growth/device-setup-mac-agent-2.png")',
            'url("/img/growth/device-setup-mac-agent-success.png")',
          ],
        },
      },
    ],
    introImage: 'url("/img/growth/device-setup-mac.png")',
    label: 'Mac',
    os: mac,
    setupImage: 'url("/img/growth/mac-setup-intro.png")',
  },
  [windows]: {
    icon: 'windows',
    installOptions: [
      {
        ...guidedSetupInstallOptions.manual,
        component: AgentSetup,
        images: {
          default: 'url("/img/growth/device-setup-windows.png")',
          steps: [
            'url("/img/growth/device-setup-windows-agent-1.png")',
            'url("/img/growth/device-setup-windows-agent-2.png")',
            'url("/img/growth/device-setup-windows-agent-success.png")',
          ],
        },
      },
      {
        ...guidedSetupInstallOptions.powershell,
        component: TerminalSetup,
        images: {
          default: 'url("/img/growth/device-setup-windows-powershell.png")',
          steps: [
            'url("/img/growth/device-setup-powershell-1.png")',
            'url("/img/growth/device-setup-powershell-2.png")',
            'url("/img/growth/device-setup-powershell-success.png")',
          ],
        },
        subheader: 'Go ahead and open a PowerShell propt with Run as Administrator.',
      },
    ],
    introImage: 'url("/img/growth/device-setup-windows.png")',
    label: 'Windows',
    os: windows,
    setupImage: 'url("/img/growth/device-setup-windows.png")',
  },
  [linux]: {
    icon: 'linux',
    installOptions: [
      {
        ...guidedSetupInstallOptions.terminal,
        component: LinuxSetup,
        images: {
          default: 'url("/img/growth/device-setup-linux.png")',
          steps: [
            'url("/img/growth/device-setup-linux-1.png")',
            'url("/img/growth/device-setup-linux-success.png")',
          ],
        },
        subheader: 'Go ahead and log into the host system as root or sudoer and then paste the folllowing command into the terminal window.',
      },
      {
        ...guidedSetupInstallOptions.puppet,
        component: LinuxSetup,
        images: {
          default: 'url("/img/growth/device-setup-puppet.png")',
          steps: [
            'url("/img/growth/device-setup-puppet-1.png")',
            'url("/img/growth/device-setup-puppet-success.png")',
          ],
        },
        subheader: 'Go ahead and copy the manifest to install the agent onto a Puppet-managed server.',
      },
      {
        ...guidedSetupInstallOptions.chef,
        component: LinuxSetup,
        images: {
          default: 'url("/img/growth/device-setup-chef.png")',
          steps: [
            'url("/img/growth/device-setup-chef-1.png")',
            'url("/img/growth/device-setup-chef-success.png")',
          ],
        },
        subheader: 'Go ahead and copy the recipe to install the agent onto a Chef-managed server.',
      },
    ],
    introImage: 'url("/img/growth/device-setup-linux.png")',
    label: 'Linux',
    os: linux,
    setupImage: 'url("/img/growth/device-setup-linux.png")',
  },
};

export const guidedSetupComponents = {
  AgentSetup,
  LinuxSetup,
  MdmSetup,
  TerminalSetup,
};
